<template>
    <div>
        <div class="page_header">
            <span class="page_title">{{ $t("changepsw.page_title") }}</span>
        </div>
        <div class="page_container">
            <el-form :size="size" label-width="180px" style="width:500px">

                <el-form-item :label="$t('changepsw.oldpsw')+'：'">
                    <el-input v-model="form.oldPsw" type="password" :placeholder="$t('changepsw.oldpsw_please')" ></el-input>
                </el-form-item>
                <el-form-item :label="$t('changepsw.newpsw')+'：'">
                    <el-input v-model="form.newPsw" type="password" :placeholder="$t('changepsw.newpsw_please')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('changepsw.confirm_newpsw')+'：'">
                    <el-input v-model="form.comfirmNewPsw" type="password" :placeholder="$t('changepsw.confirm_please')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">{{$t('public.save')}}</el-button>

                </el-form-item>


            </el-form>
        </div>
    </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
import {validatePassword} from "@/utils/validate"
export default {
    name: "changePsw",
    data() {
        return {
            form: {
                optID: 0,
                userType: 0,
                oldPsw: "",
                newPsw: "",
                comfirmNewPsw: "",
            }
        }
    },
    computed: {
        size() {
            return this.$store.getters.size
        },
        operator() {
            return this.$store.getters.operator
        }
    },
    methods: {
        onSubmit() {
           

            if (!this.form.oldPsw) {
                this.$message.warning(this.$t('changepsw.oldpsw_please'));
                return;
            }
            if (!this.form.newPsw) {
                this.$message.warning(this.$t('changepsw.newpsw_please'));
                return;
            }
            if (!this.form.comfirmNewPsw) {
                this.$message.warning(this.$t('changepsw.confirm_please'));
                return;
            }

            // if (this.form.newPsw == this.form.oldPsw) {
            //     this.$message.warning('新密码不能和旧密码相同');
            //     return;
            // }
            if (this.form.newPsw != this.form.comfirmNewPsw) {
                this.$message.warning(this.$t('changepsw.newpsw_nosame'));
           
                return;
            }

            //密码强度验证

            
            if(!validatePassword(this.form.newPsw)){
                this.$message.warning(this.$t('changepsw.password_strong'));
           
                return ;

            }
         

            //提交接口，退出，重新登录
            this.$api.changePsw({
                optID: this.operator.OperatorId,
                userType: 0,
                oldPsw: Base64.encode(this.form.oldPsw),
                newPsw: Base64.encode(this.form.newPsw)

            }).then(async res => {
                if (res.code == 200) {
                    this.$message.success(this.$t('changepsw.change_success'));
                    await this.$store.dispatch('user/logout')
                    this.$router.push(`/login?redirect=${this.$route.fullPath}`)

                }else{
                    
                    this.$message.error(this.$t('changepsw.change_fail'));//res.message
                }
            });

        }
    }
}
</script>
<style scoped>

</style>